import React, { useCallback, useEffect, useState } from "react";
import algoliasearch from "algoliasearch/lite";
import { Configure, Highlight, InfiniteHits, InstantSearch, SearchBox } from "react-instantsearch-hooks-web";
import { Link } from "./link";
import clsx from "clsx";
import { useToggle } from "@mantine/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var searchClient = algoliasearch(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID || "OZK99PDWYT", process.env.NEXT_PUBLIC_ALGOLIA_API_KEY || "f1594e8f7295287a0caf1bec547153df");
var algoliaIndex = (process.env.NEXT_PUBLIC_VERCEL_ENV || "development") + "_storyblok";
var categories = [{
  id: "information",
  text: "Cancer Information"
}, {
  id: "prevention",
  text: "Cancer Prevention"
}, {
  id: "support",
  text: "Support"
}, {
  id: "involved",
  text: "Be Involved"
}, {
  id: "research",
  text: "Research"
}, {
  id: "blog",
  text: "Blog"
}, {
  id: "careers",
  text: "Careers"
}, {
  id: "professionals",
  text: "Professionals"
}];
export var Search = props => {
  var {
    perPage = 16,
    isOpen = false,
    placeholder = "Search...",
    label = "Search",
    showLogo = true,
    className,
    children,
    type
  } = props;
  var [show, setShow] = useState(isOpen);
  var [filters, setFilters] = useState("");
  var [selectedCategory, setSelectedCategory] = useState(categories.find(c => c.id === type));
  var [showCategories, toggleShowCategories] = useToggle();
  var selectCategory = useCallback(category => {
    setSelectedCategory(selectedCategory && category.id === selectedCategory.id ? null : category);
    toggleShowCategories(false);
  }, [setSelectedCategory, toggleShowCategories]);
  useEffect(() => {
    var _filters = "variant:cancerqld";

    if (selectedCategory) {
      _filters += ",type:" + selectedCategory.id;
    }

    setFilters(_filters);
  }, [selectedCategory]);
  var closeSearch = useCallback(() => {
    setShow(false);
    document.body.style.overflow = "auto";
  }, []);
  var openSearch = useCallback(() => {
    setShow(true);
    document.body.style.overflow = "hidden";
  }, []);
  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);
  return children && !show ? /*#__PURE__*/_jsx("div", {
    onClick: openSearch,
    children: children
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(className, {
        "fixed z-50 overflow-y-auto inset-0 w-full h-full": show
      }),
      children: /*#__PURE__*/_jsxs("div", {
        className: "w-full h-auto max-w-2xl mx-auto",
        children: [/*#__PURE__*/_jsxs(InstantSearch, {
          searchClient: searchClient,
          indexName: algoliaIndex,
          children: [/*#__PURE__*/_jsxs("div", {
            className: clsx("", {
              "sticky top-0 p-3 bg-ccq-dark-blue": show
            }),
            children: [show && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs("div", {
                className: "flex justify-between cursor-pointer",
                children: [/*#__PURE__*/_jsxs("div", {
                  className: "flex -xl sm:text-3xl mb-3 ",
                  children: [showLogo && /*#__PURE__*/_jsx("div", {
                    className: "shrink mr-2",
                    children: /*#__PURE__*/_jsx("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 118.66 115.52",
                      className: "h-6 sm:h-10",
                      children: /*#__PURE__*/_jsx("path", {
                        className: "fill-[#ffc629]",
                        d: "M64.07,52.42c2.65-.31,10.35-4.08,14.19-6.03,.21-.1,.39,.19,.19,.34-2.85,2.12-8.11,6.14-11.75,9.62-1.41,1.34-1.35,3.59,.13,4.87,2.74,2.38,6.75,5.25,9.07,6.86,.2,.14,.03,.44-.19,.35-2.62-1.18-7.27-3.19-11.01-4.49-1.87-.66-3.9,.46-4.33,2.4l-3.53,16.05c-.05,.23-.39,.21-.39-.03-.05-2.93-.18-8.97-.59-13.37-.21-2.35-2.76-3.73-4.84-2.61-4.79,2.53-10.05,6.1-13.17,8.29-.2,.15-.43-.14-.25-.31,2.67-2.49,6.23-5.98,8.7-8.96,.56-.68,1.8-1.73,2.06-2.51-1.97-1.12-3.29-2.53-3.56-2.83-.77-.86-1.54-1.63-2.29-2.33C8.13,53.16,0,77.05,0,77.05c17.21,6.81,26.66,4.3,27.49,4.16,0,0-7.95,12.45-6.51,34.31,30.07-5.02,35.71-25.93,35.71-25.93,6.95,15.94,28.58,14.03,28.58,14.03,0,0,5.93-18.94-2.48-31.01,22.07,3.86,35.86-21.9,35.86-21.9,0,0-13.22-10.04-30.68-9.09l-.02,.02c2.6-3.67,12-19.16,3.5-41.66C56.18,10.53,57.28,36.42,57.8,41.21c-5.96-9.99-4.89-20.2-11.69-25.12-4.89-3.79-13.52-1.97-20.41,4.19-7.06,6.3-9.8,14.92-6.22,20.19,.07,.05,.13,.11,.19,.18,.02,.02,.03,.03,.05,.05h0c.16,.19,.36,.38,.58,.55,.71,.55,1.67,.99,2.7,1.27,1.36,.37,2.83,.58,4.32,.57,2.97,0,6-.7,8.76-1.96,2.77-1.26,5.25-3.15,7.36-5.41,2.08-2.28,3.74-4.98,5.02-7.88h0c.12-.25,.38-.39,.65-.35,.05,0,.11,.02,.16,.05,.28,.12,.42,.45,.33,.74-1.01,3.13-2.5,6.15-4.59,8.79-2.09,2.63-4.73,4.87-7.76,6.44-3.02,1.58-6.38,2.57-9.84,2.77-.26,0-.53,.02-.79,.02,6.44,3.31,13.07,3.95,20.42,12.11,2.11,2.34,8.19,6.89,14.18,1.69,3.74-3.24,2.84-7.67,2.84-7.67Z"
                      })
                    })
                  }), /*#__PURE__*/_jsx("div", {
                    className: "text-white",
                    children: label
                  }), /*#__PURE__*/_jsx("div", {
                    className: "ml-2 text-white   border-b sm:border-b-2 border-ccq-yellow",
                    onClick: () => toggleShowCategories(),
                    children: selectedCategory ? "in " + selectedCategory.text : "Everywhere"
                  })]
                }), /*#__PURE__*/_jsx("svg", {
                  onClick: closeSearch,
                  xmlns: "http://www.w3.org/2000/svg",
                  className: "h-5 w-5 shrink text-white",
                  viewBox: "0 0 20 20",
                  fill: "currentColor",
                  children: /*#__PURE__*/_jsx("path", {
                    fillRule: "evenodd",
                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                    clipRule: "evenodd"
                  })
                })]
              }), showCategories && /*#__PURE__*/_jsx("div", {
                className: "text-white grid gap-2 sm:grid-cols-2 md:grid-cols-4",
                children: categories.map(category => /*#__PURE__*/_jsx("div", {
                  onClick: () => selectCategory(category),
                  className: clsx("mb-2 py-1 pr-3 py-1 border whitespace-nowrap cursor-pointer pl-3 hover:bg-ccq-yellow hover:text-black hover:border-ccq-yellow", selectedCategory && selectedCategory.id === category.id ? "order-first bg-ccq-yellow border-ccq-yellow text-black" : "border-white"),
                  children: category.text
                }, category.id))
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "relative ",
              children: [/*#__PURE__*/_jsx(SearchBox, {
                classNames: {
                  root: "",
                  form: "",
                  input: "w-full pl-10 border border-ccq-dark-blue focus:ring block px-3 py-1.5 border border-grey-300/20 rounded",
                  submit: "hidden",
                  reset: "hidden",
                  loadingIndicator: "hidden",
                  submitIcon: "hidden",
                  resetIcon: "hidden",
                  loadingIcon: "hidden"
                },
                onFocus: openSearch,
                placeholder: placeholder
              }), /*#__PURE__*/_jsx("div", {
                className: "flex flex-col  items-center justify-center h-full  absolute left-0 top-0 w-10",
                children: /*#__PURE__*/_jsx("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  className: "h-6 w-6 stroke-ccq-dark-blue",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  strokeWidth: 2,
                  children: /*#__PURE__*/_jsx("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  })
                })
              })]
            })]
          }), show && /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(InfiniteHits, {
              hitComponent: Hit,
              classNames: {
                loadPrevious: "my-4 pl-2",
                loadMore: "my-7 w-full text-center underline",
                disabledLoadPrevious: "hidden",
                disabledLoadMore: "hidden"
              }
            })
          }), /*#__PURE__*/_jsx(Configure, {
            hitsPerPage: show ? perPage : 0,
            facetFilters: filters
          })]
        }), show && /*#__PURE__*/_jsx("div", {
          onClick: closeSearch,
          className: "bg-[#e5e5e5] -z-10 fixed inset-0 w-full h-full"
        })]
      })
    })
  });
};

function Hit(_ref) {
  var {
    hit
  } = _ref;
  return /*#__PURE__*/_jsx(Link, {
    href: hit.slug,
    className: "no-underline",
    children: /*#__PURE__*/_jsxs("article", {
      className: "bg-white flex mt-1 shadow p-3 hover:shadow-md",
      children: [hit.image && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("img", {
          className: "w-24 mr-4",
          src: hit.image,
          alt: hit.name
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex-1",
        children: [hit.title && /*#__PURE__*/_jsx("div", {
          className: "text-xl",
          children: /*#__PURE__*/_jsx(Highlight, {
            attribute: "title",
            hit: hit
          })
        }), hit.description && /*#__PURE__*/_jsx("small", {
          className: "font-normal",
          children: /*#__PURE__*/_jsx(Highlight, {
            attribute: "description",
            hit: hit
          })
        })]
      })]
    })
  });
}
//# sourceMappingURL=search.js.map